<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-02 11:45:35
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-02-22 15:28:36
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/brandProduct/components/productType.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="8">
        <el-button :icon="Plus" type="primary" @click="addType($event)">添加类型</el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="16">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="类型名称">
            <el-input v-model.trim="queryForm.likeExhibitName" clearable placeholder="请输入类型名称" />
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <!-- <el-table-column label="序号" prop="id" /> -->
      <el-table-column label="名称" prop="name" show-overflow-tooltip />

      <el-table-column label="操作" show-overflow-tooltip width="420">
        <template #default="{ row }">
          <el-button plain type="info" @click="handleEdit(row)">编辑</el-button>
          <el-button plain type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />

    <edit
      ref="editRef"
      :enterprise-code="queryForm.enterpriseCode"
      :exhibitor-code="queryForm.exhibitorCode"
      @fetch-data="fetchData"
    />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { queryProductAttribute, editProductAttribute } from '@/api/brand'
  import { useRoute } from 'vue-router'
  export default defineComponent({
    name: 'Brand',
    components: {
      Edit: defineAsyncComponent(() => import('./editProductType')),
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          likeName: '',
          pageNum: 1,
          pageSize: 10,
          enterpriseCode: route.query.enterpriseCode,
          exhibitorCode: route.query.exhibitorCode,
          enterpriseType: route.query.enterpriseCode ? 'ENTERPRISE' : 'EXHIBITOR',
          type: 'TYPE',
        },
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        enterpriseCode: '',
        syncProductRef: null,
        generateWxRef: null,
      })
      const handleEdit = (row) => {
        state.editRef.showEdit(row)
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.id) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            row.delFlag = true
            row.enterpriseCode = state.queryForm.enterpriseCode
            await editProductAttribute(row)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        const { data } = await queryProductAttribute(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const productStatusChange = async (row) => {
        try {
          let obj = {
            exhibitCode: row.exhibitCode,
            status: row.status,
          }
          await editBrandProductStatus(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }

        fetchData()
      }

      onActivated(() => {
        state.queryForm = {
          likeName: '',
          pageNum: 1,
          pageSize: 10,
          enterpriseCode: route.query.enterpriseCode,
          exhibitorCode: route.query.exhibitorCode,
          enterpriseType: route.query.enterpriseCode ? 'ENTERPRISE' : 'EXHIBITOR',
          type: 'TYPE',
        }
        fetchData()
      })

      const addType = () => {
        state.editRef.showEdit()
      }

      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        productStatusChange,
        handleConfig,
        Delete,
        Search,
        Plus,
        addType,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
